import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    expired: {
        color: theme.palette.error.main,
        fontWeight: 'bold',
    },
    countdown: {
        display: "flex",
        gap: "clamp(8px, 2.5vw, 20px)",
        justifyContent: "center",
        maxWidth: "100%"
    },
    timerBox: {
        background: "var(--darkBlue)",
        color: "var(--white)",
        borderRadius: "8px",
        width: "clamp(64px, 18vw, 130px)",
        padding: "clamp(14px, 3vw, 26px) 0 clamp(10px, 2vw, 18px)",
        boxShadow: "0 8px 24px rgba(0, 22, 65, .25)",
        border: "1px solid rgba(255, 255, 255, .08);"
    },
    timerValue: {
        fontSize: "clamp(1.8rem, 8vw, 3.6rem)",
        fontWeight: 700,
        fontVariantNumeric: "tabular-nums",
        lineHeight: 1,
        textAlign: "center"
    },
    timerLabel: {
        marginTop: "10px",
        fontSize: "clamp(.6rem, 2vw, .85rem)",
        letterSpacing: ".12em",
        textTransform: "uppercase",
        color: "var(--white)",
        textAlign: "center"
    }
}));

const parseAESTDate = (target) => {
    if (!target) return new Date();
    if (target instanceof Date) return target;
    if (typeof target === 'number') return new Date(target);

    const hasTimezone = /(Z|[+-]\d{2}:?\d{2})$/.test(target.trim());

    if (hasTimezone) {
        return new Date(target);
    }

    const tempDate = new Date(target);
    const month = tempDate.getMonth();
    const dateNum = tempDate.getDate();
    const dayOfWeek = tempDate.getDay();
    let isAEDT = month > 8 || month < 3;
    const offset = isAEDT ? '+11:00' : '+10:00';

    return new Date(`${target}${offset}`);
};

const calculateTimeLeft = (target) => {
    const targetDate = parseAESTDate(target);
    const difference = targetDate.getTime() - Date.now();
    let timeLeft = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    };

    if (difference > 0) {
        timeLeft = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
        };
    }

    return { difference, timeLeft };
};

function TimerBox({ value, label }) {
    const classes = useStyles();
    return <Box className={classes.timerBox}>
        <Box className={classes.timerValue}>
            {value}
        </Box>
        <Box className={classes.timerLabel}>
            {label}
        </Box>
    </Box>;
}

//<div class="countdown" data-date-target="2026-09-26T11:59:59+10:00"></div>
export default function Countdown({ targetDate }) {
    const classes = useStyles();
    const [timeLeftData, setTimeLeftData] = useState(() => calculateTimeLeft(targetDate));

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeftData(calculateTimeLeft(targetDate));
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    const { difference, timeLeft } = timeLeftData;

    const timerComponents = [];

    Object.keys(timeLeft).forEach((interval) => {
        timerComponents.push(<TimerBox key={interval} value={String(timeLeft[interval]).padStart(2, '0')} label={interval} />);
    });

    const isComplete = difference <= 0;

    return <Box className={classes.countdown} role="timer" aria-live="polite">
        {timerComponents}
    </Box>;
}